import { createSelector } from 'reselect';
import { RootState } from '../../model/rootReducer';

const currentUser = (state: RootState) => state.oidc.user;

export const isUserLoggedIn = createSelector(
  currentUser,
  (currentUser) => (currentUser !== null),
);

export const selectUserRoles = createSelector(
  currentUser,
  (currentUser) => (currentUser?.profile?.role),
);